<template>
  <b-container
    v-if="blocks"
    class="AppSection"
    :class="backgroundClass"
    fluid
  >
    <b-container
      class="AppSection__content"
      :class="textClass"
    >
      <component
        :is="component"
        v-for="{ _uid, component, ...props } in blocks"
        :key="_uid"
        v-editable="props"
        v-bind="props"
      />
    </b-container>
  </b-container>
</template>

<script>
import AppRow from '@/components/blocks/AppRow'

export default {
  name      : 'AppSection',
  components: { AppRow },
  props     : {
    blocks: {
      required: true,
      type    : Array,
    },
    variant: {
      type   : String,
      default: '',
    },
    size: {
      type   : String,
      default: 'medium',
    },
  },
  computed: {
    backgroundClass () {
      return `bg-${this.variant} bg-cover bg-center d-flex AppSection__${this.size}`
    },
    imageOrder () {
      if (this.imagePosition === 'right') return true

      return false
    },
    textClass () {
      let className = ''
      switch (this.variant) {
        case 'primary':
          className = 'text-light'
          break
        case 'secondary':
          className = 'text-dark'
          break
        case 'light':
          className = 'text-dark'
          break
        case 'dark':
          className = 'text-light'
          break
      }
      return className
    },
  },
}
</script>

<style lang="scss" scoped>
.AppSection {
  &__small {
    padding-top: $spacer;
    padding-bottom: $spacer;
  }
  &__medium {
    padding-top: $spacer * 4;
    padding-bottom: $spacer * 4;
  }
  &__large {
    padding-top: $spacer * 6;
    padding-bottom: $spacer * 6;
  }
}
</style>
